import { CORPORATE_CUSTOMER } from "constants/customerTypes";

/**
 * Calculates the leasing price based on the leasing offer and customer type.
 *
 * @param {object} leasingOffer - The leasing offer object, containing either netRate or grossRate.
 * Each rate should have a `value` property.
 * @param {string} customerType - The type of customer, which can affect the pricing calculation.
 * Recognized customer types include CORPORATE_CUSTOMER and "COMMERCIAL".
 * @returns {number | undefined} The calculated leasing price, or undefined if the price cannot
 * be calculated.
 * The price is derived from netRate for CORPORATE_CUSTOMER and "COMMERCIAL",
 * and from grossRate for other customer types, divided by 100.
 */
export const getLeasingPrice = (leasingOffer, customerType) => {
  const price = [CORPORATE_CUSTOMER, "COMMERCIAL"].some(
    (item) => item === customerType,
  )
    ? leasingOffer?.netRate?.value / 100
    : leasingOffer?.grossRate?.value / 100;

  return price || undefined;
};
